<div class="conn-card">
  <div class="conn-card-body">
    <div
      class="conn-avatar"
      [style.background-color]="avatarColor"
    >
      {{ initial }}
    </div>
    <div class="conn-info">
      <button
        type="button"
        class="conn-name"
        [title]="name"
        (click)="nameClick.emit($event); $event.stopPropagation()"
      >
        {{ name }}
      </button>
      <div class="conn-meta" *ngIf="providerLabel || modelLabel">
        <span *ngIf="providerLabel">{{ providerLabel }}</span>
        <span class="conn-meta-divider" *ngIf="providerLabel && modelLabel"></span>
        <span class="conn-meta-model" *ngIf="modelLabel" [title]="modelLabel">{{ modelLabel }}</span>
      </div>
    </div>
  </div>

  <div class="conn-card-footer">
    <button
      *ngIf="showTest"
      type="button"
      class="conn-test-btn"
      [class.conn-test-btn--testing]="isTesting"
      [disabled]="isTesting"
      (click)="test.emit($event); $event.stopPropagation()"
    >
      <span *ngIf="isTesting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      {{ isTesting ? "Testing..." : "Test Connection" }}
    </button>
    <span *ngIf="!showTest"></span>

    <div class="conn-actions">
      <button
        *ngIf="showEdit"
        type="button"
        class="accello-icon-btn"
        matTooltip="Edit"
        matTooltipPosition="above"
        (click)="edit.emit($event); $event.stopPropagation()"
      >
        <img [src]="'images/virtusa-icons/edit_client.svg' | assetUrl" alt="edit" />
      </button>
      <button
        *ngIf="showDelete"
        type="button"
        class="accello-icon-btn"
        matTooltip="Delete"
        matTooltipPosition="above"
        (click)="delete.emit($event); $event.stopPropagation()"
      >
        <img [src]="'images/virtusa-icons/delete-red.svg' | assetUrl" alt="delete" />
      </button>
    </div>
  </div>
</div>
